import { Directive, OnDestroy } from '@angular/core';
import { Exercicio, FuncaoService, GlobalService, Login, Relatorio } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BalancoService } from '../service/balanco.service';

@Directive()
export class Anexo14ABalanco implements OnDestroy {
  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;
  private login: Login = new Login();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected balancoServico: BalancoService,
    protected exercicio: Exercicio) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public montarRelatorio(exercicio: Exercicio, orgaos: number[]) {
    this.balancoServico.obterBalancoPatrimonialA(this.exercicio.id, orgaos)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado(
          `ANEXO 14 A - QUADRO DEMONSTRATIVO DAS CONTAS ANALÍTICAS DO ATIVO FINANCEIRO`
          , this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.conteudo(dados, exercicio),
          'portrait', 'ANEXO 14 A - QUADRO DEMONSTRATIVO DAS CONTAS ANALÍTICAS DO ATIVO FINANCEIRO',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, false, true);
      });
  }

  private conteudo(dados: any[], exercicio: Exercicio): {}[] {
    // monta o cabecalho
    const registros: {}[] = [
      [{
        text: `EXERCÍCIO ${exercicio.ano}`, fontSize: 13,
        alignment: 'center', bold: true, colSpan: 6, border: [true, true, true, false]
      }, '', ''],
      [
        {
          text: 'ATIVO FINANCEIRO',
          alignment: 'center',
          colSpan: 3,
        }, '', ''
      ],
      [{
        text: 'TÍTULOS',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'VALOR',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        colSpan: 2
      }, {
        text: '',
        alignment: 'center',
        fontSize: 7,
        bold: true,
      }],
      [
        { text: '' },
        {
          text: 'Exercício Atual',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        }, {
          text: 'Exercício Anterior',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        }
      ]
    ];

    let col2 = 0;
    let col3 = 0;
    for (const item of dados[0]) {
      registros.push([
        {
          text: item.nome, bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            item.valor_atual), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            item.valor_anterior), alignment: 'right', bold: true, fontSize: 7
        }
      ]);

      col2 += +item.valor_atual;
      col3 += +item.valor_anterior;
    }

    registros.push([{
      text: 'TOTAL', bold: true,
      alignment: 'left', fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col2),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col3),
      alignment: 'right', bold: true, fontSize: 7
    }]);

    registros.push([{
      text: '', colSpan: 3, margin: [10, 10, 10, 10], border: [false, false, false, false]
    }, '', '']);


    registros.push(
      [
        {
          text: 'PASSIVO FINANCEIRO',
          alignment: 'center',
          colSpan: 3, margin: [5, 5, 5, 5]
        }, '', ''
      ],
      [{
        text: 'TÍTULOS',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'VALOR',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        colSpan: 2
      }, {
        text: '',
        alignment: 'center',
        fontSize: 7,
        bold: true,
      }],
      [
        { text: '' },
        {
          text: 'Exercício Atual',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        }, {
          text: 'Exercício Anterior',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        }
      ]
    );
    col2 = 0;
    col3 = 0;
    const grupos = this.funcaoService.agrupar(dados[1], ['grupo'], ['valor_atual', 'valor_anterior']);
    for (const item of grupos) {
      registros.push([
        {
          text: item.grupo['grupo'], bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            item.totalizadores['valor_atual']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            item.totalizadores['valor_anterior']), alignment: 'right', bold: true, fontSize: 7
        }
      ]);

      col2 += +item.totalizadores['valor_atual'];
      col3 += +item.totalizadores['valor_anterior'];
      for (const it of item.registros) {
        if (it['nome'] !== '') {
          registros.push([
            {
              text: it['nome'], fontSize: 8
            },
            {
              text: this.funcaoService.convertToBrNumber(it['valor_atual']), alignment: 'right',
              fontSize: 8
            },
            {
              text: this.funcaoService.convertToBrNumber(it['valor_anterior']), alignment: 'right',
              fontSize: 8
            }
          ]);
        }
      }

    }

    registros.push([{
      text: 'TOTAL', bold: true,
      alignment: 'left', fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col2),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col3),
      alignment: 'right', bold: true, fontSize: 7
    }]);

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: ['*', 120, 120],
        body: registros
      }
    }];
  }

}
